import { createContext } from "react";

const StorageContext = createContext(null);

export default StorageContext; 